(function ($) {
  // This is to change the toggle back to normal if someone clicks the offcanvas backdrop to close the menu
  document.addEventListener("DOMContentLoaded", function () {
    var myOffcanvas = document.getElementById("navbarNavOffcanvas");
    var navIcon = document.querySelector(".smnav");

    if (myOffcanvas && navIcon) {
      myOffcanvas.addEventListener("show.bs.offcanvas", function () {
        navIcon.classList.add("active");
      });
      myOffcanvas.addEventListener("hide.bs.offcanvas", function () {
        navIcon.classList.remove("active");
      });
    }
  });

  // Optimized Parallax Tracker
  let ticking = false;

  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        document.body.style.setProperty("--scroll-y", window.scrollY + "px");
        ticking = false;
      });
      ticking = true;
    }
  });

  jQuery(document).ready(function ($) {
    // 2. Search Toggle Logic
    $(".search-toggle").click(function (e) {
      e.preventDefault();
      $("#search-form-container").slideToggle();
    });
    $(".navbar-toggler").click(function () {
      $("#search-form-container").slideUp();
    });

    // ---------------------------------------------------------
    // 3. CUSTOM NAV LOGIC (Applied to ALL Dropdowns)
    // ---------------------------------------------------------

    // A. Disable Bootstrap's default handling
    var $dropdownLinks = $(".navbar-nav .dropdown-toggle");
    $dropdownLinks.each(function () {
      var $link = $(this);
      $link.removeAttr("data-bs-toggle");
      $link.removeAttr("data-toggle");
      $link.removeAttr("aria-expanded");
    });

    // B. The Target-Based Handler (Updated)
    $(document).on("click", ".navbar-nav .dropdown-toggle", function (e) {
      var $el = $(this);
      var url = $el.attr("href");

      // CASE 1: Placeholder Links (#)
      if (!url || url === "#" || url === "javascript:;") {
        e.preventDefault();
        e.stopPropagation();
        toggleMenu($el);
        return;
      }

      // CASE 2: Real Links
      // Check if the actual click target is the text span we added in PHP
      var isTextClick = $(e.target).closest(".link-text-target").length > 0;

      if (isTextClick) {
        // User clicked the actual text. Let the link open normally.
        e.stopPropagation();
        return;
      } else {
        // User clicked the arrow zone or background. Expand accordion.
        e.preventDefault();
        e.stopPropagation();
        toggleMenu($el);
      }
    });

    // C. The Custom Accordion Function
    function toggleMenu($clickedLink) {
      var $submenu = $clickedLink.next(".dropdown-menu");
      var isOpen = $submenu.hasClass("show");

      $clickedLink
        .closest(".navbar-nav")
        .find(".dropdown-menu.show")
        .not($submenu)
        .removeClass("show");
      $clickedLink
        .closest(".navbar-nav")
        .find(".dropdown-toggle.show")
        .not($clickedLink)
        .removeClass("show")
        .attr("aria-expanded", "false");

      if (isOpen) {
        $submenu.removeClass("show");
        $clickedLink.removeClass("show");
        $clickedLink.attr("aria-expanded", "false");
      } else {
        $submenu.addClass("show");
        $clickedLink.addClass("show");
        $clickedLink.attr("aria-expanded", "true");

        setTimeout(function () {
          var $container = $clickedLink.closest(".offcanvas-body");
          if ($container.length) {
            var contextBuffer = 65;
            var containerTop = $container.offset().top;
            var linkTop = $clickedLink.offset().top;
            var currentScroll = $container.scrollTop();
            var newScroll =
              currentScroll + (linkTop - containerTop) - contextBuffer;

            $container.animate({ scrollTop: newScroll }, 200);
          } else {
            $clickedLink[0].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 50);
      }
    }

    // D. Close menu when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".navbar-nav").length) {
        $(".dropdown-menu.show").removeClass("show");
        $(".dropdown-toggle.show")
          .removeClass("show")
          .attr("aria-expanded", "false");
      }
    });

    // 4. Submenu deep nesting handling (Level 3+)
    $(".dropdown-menu > li > .dropdown-menu")
      .parent()
      .addClass("dropdown-submenu")
      .find(" > .dropdown-item")
      .attr("href", "javascript:;")
      .addClass("dropdown-toggle");

    $(".dropdown-submenu > a").on("click", function (e) {
      var dropdown = $(this).parent().find(" > show");
      $(".dropdown-submenu .dropdown-menu")
        .not(dropdown)
        .removeClass("show remove");
      $(this).next(".dropdown-menu").toggleClass("show toggle");
      e.stopPropagation();
    });

    $(".dropdown").on("hidden.bs.dropdown", function () {
      $(".dropdown-menu.show").removeClass("show");
    });

    // 5. Optimized Animation Observer (With "Popping" Fix)
    const the_animation = document.querySelectorAll(".animation");

    const observerOptions = {
      threshold: 0.01,
      rootMargin: "0px 0px 100px 0px",
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting ||
          entry.target.classList.contains("instant-load")
        ) {
          // Use requestAnimationFrame to ensure the browser sees the 'hidden' state first
          window.requestAnimationFrame(() => {
            entry.target.classList.add("scroll-animation");
          });

          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    the_animation.forEach((el) => observer.observe(el));

    // ---------------------------------------------------------
    // 6. Scroll Up Indicator Logic (DOM Injection Method)
    // ---------------------------------------------------------
    var $offcanvasBody = $(".offcanvas-body");

    // 6a. Inject the arrow element immediately BEFORE the scrollable body
    // This places it safely outside the scroll area so it won't get clipped.
    if ($(".scroll-up-arrow").length === 0) {
      $offcanvasBody.before('<div class="scroll-up-arrow"></div>');
    }

    var $upArrow = $(".scroll-up-arrow");

    // 6b. Listen for scrolling
    $offcanvasBody.on("scroll", function () {
      var currentScroll = $(this).scrollTop();

      // Show arrow if scrolled down more than 20px
      if (currentScroll > 20) {
        $upArrow.addClass("visible");
      } else {
        $upArrow.removeClass("visible");
      }
    });

    // 6c. Trigger check on accordion click
    $(".navbar-nav .dropdown-toggle").on("click", function () {
      setTimeout(function () {
        $offcanvasBody.trigger("scroll");
      }, 350);
    });

    // ---------------------------------------------------------
    // 7. Banner Hover Glow Effect
    // ---------------------------------------------------------
    const $glowBanners = $(".has-hover-glow");

    if ($glowBanners.length) {
      $glowBanners.on("mousemove", function (e) {
        // "this" refers to the specific banner being hovered
        const rect = this.getBoundingClientRect();

        // Calculate mouse position relative to the element
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Update the CSS Variables directly on the element
        this.style.setProperty("--mouse-x", x + "px");
        this.style.setProperty("--mouse-y", y + "px");
      });
    }
  });
})(jQuery);
(function () {
  var ua = navigator.userAgent;
  var isSafari =
    /Safari/i.test(ua) &&
    !/Chrome/i.test(ua) &&
    !/CriOS/i.test(ua) &&
    !/FxiOS/i.test(ua) &&
    !/EdgiOS/i.test(ua);

  if (!isSafari) return;

  function processYouTubeIframes() {
    var ytDomainRegex =
      /https?:\/\/(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.be)\//i;

    document.querySelectorAll("iframe[data-src]").forEach(function (iframe) {
      var dataSrc = iframe.getAttribute("data-src");

      if (dataSrc && ytDomainRegex.test(dataSrc)) {
        // Ensure referrerpolicy is set to prevent Error 153 on Safari
        if (!iframe.hasAttribute("referrerpolicy")) {
          iframe.setAttribute(
            "referrerpolicy",
            "strict-origin-when-cross-origin",
          );
        }

        iframe.setAttribute("src", dataSrc);
        iframe.removeAttribute("data-src");
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", processYouTubeIframes);
  } else {
    processYouTubeIframes();
  }
})();
